import { MultiLanguageWrapper } from "@iddataweb/idw-common-ui/types";
import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { MessagingTemplatePermissions, MessagingTemplate } from "@idw-types/data/messaging-template";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { MESSAGING_TEMPLATE_ID_PATTERN } from "@constants/url-parameter-patterns";
import { MessagingTemplateTypes } from "@enums/messaging-template-types";
import { EntityStatusTypes } from "@enums/entity-status-types";

export const updateMessagingTemplateRequest = async (
    id: string,
    template: string,
    name: string,
    companyId: string,
    relyingPartyId: string,
    type: MessagingTemplateTypes,
    languageFiles: Partial<MultiLanguageWrapper<string>>,
    status: EntityStatusTypes,
    uuid: string,
    permissions: MessagingTemplatePermissions
): Promise<GenericNetworkResponse<MessagingTemplate>> => {
    const route = injectCustomIdParameter(apiRoutes.axnadminCore.messagingTemplateWithId, id, MESSAGING_TEMPLATE_ID_PATTERN);
    const body: MessagingTemplate = {
        id,
        template,
        name,
        companyID: companyId,
        relyingPartyID: relyingPartyId,
        type,
        languageFiles,
        status,
        uuid,
        permissions
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};